import CampusRootLayout from "./CampusRootLayout";

export default CampusRootLayout;
